import {
  CLEAR_FAMILY_CLAN,
  GET_FAMILY_CLANS_FAILURE,
  GET_FAMILY_CLANS_REQUEST,
  GET_FAMILY_CLANS_SUCCESS,
  GET_FAMILY_CLAN_ANALYTICS_FAILURE,
  GET_FAMILY_CLAN_ANALYTICS_REQUEST,
  GET_FAMILY_CLAN_ANALYTICS_SUCCESS,
  GET_FAMILY_CLAN_FAILURE,
  GET_FAMILY_CLAN_HISTORY_FAILURE,
  GET_FAMILY_CLAN_HISTORY_REQUEST,
  GET_FAMILY_CLAN_HISTORY_SUCCESS,
  GET_FAMILY_CLAN_RANKING_FAILURE,
  GET_FAMILY_CLAN_RANKING_REQUEST,
  GET_FAMILY_CLAN_RANKING_SUCCESS,
  GET_FAMILY_CLAN_REQUEST,
  GET_FAMILY_CLAN_SUCCESS,
} from "./types";

const initialState = {
  familyClans: [],
  familyClansPeriod: null,
  selectedFamilyClan: null,
  analytics: null,
  history: [],
  ranking: [],
  loading: false,
  detailLoading: false,
  analyticsLoading: false,
  historyLoading: false,
  rankingLoading: false,
  error: null,
  detailError: null,
  analyticsError: null,
  historyError: null,
  rankingError: null,
};

const familyClanReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FAMILY_CLANS_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_FAMILY_CLANS_SUCCESS:
      return {
        ...state,
        loading: false,
        familyClans: action.payload?.familyClans || [],
        familyClansPeriod: action.payload?.period || null,
      };
    case GET_FAMILY_CLANS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case GET_FAMILY_CLAN_REQUEST:
      return { ...state, detailLoading: true, detailError: null };
    case GET_FAMILY_CLAN_SUCCESS:
      return { ...state, detailLoading: false, selectedFamilyClan: action.payload };
    case GET_FAMILY_CLAN_FAILURE:
      return { ...state, detailLoading: false, detailError: action.payload };
    case GET_FAMILY_CLAN_ANALYTICS_REQUEST:
      return { ...state, analyticsLoading: true, analyticsError: null };
    case GET_FAMILY_CLAN_ANALYTICS_SUCCESS:
      return { ...state, analyticsLoading: false, analytics: action.payload };
    case GET_FAMILY_CLAN_ANALYTICS_FAILURE:
      return {
        ...state,
        analyticsLoading: false,
        analyticsError: action.payload,
      };
    case GET_FAMILY_CLAN_HISTORY_REQUEST:
      return { ...state, historyLoading: true, historyError: null };
    case GET_FAMILY_CLAN_HISTORY_SUCCESS:
      return { ...state, historyLoading: false, history: action.payload || [] };
    case GET_FAMILY_CLAN_HISTORY_FAILURE:
      return { ...state, historyLoading: false, historyError: action.payload };
    case GET_FAMILY_CLAN_RANKING_REQUEST:
      return { ...state, rankingLoading: true, rankingError: null };
    case GET_FAMILY_CLAN_RANKING_SUCCESS:
      return { ...state, rankingLoading: false, ranking: action.payload || [] };
    case GET_FAMILY_CLAN_RANKING_FAILURE:
      return { ...state, rankingLoading: false, rankingError: action.payload };
    case CLEAR_FAMILY_CLAN:
      return {
        ...state,
        selectedFamilyClan: null,
        analytics: null,
        history: [],
        detailError: null,
        analyticsError: null,
        historyError: null,
      };
    default:
      return state;
  }
};

export default familyClanReducer;
